import React, { useEffect, useState, useRef } from 'react';
import { Parallax } from 'react-parallax';
import './Aboutus.css'
import logoBanner from '../../Assests/4f71dc90cc29b4ed69de0636891985f083fdf283.png'
import facebook from '../../Assests/ee50e467241a4a5b1469e6fbe4e1491df7da03c8.png'
import x from '../../Assests/974b66e5853edd33915dc8029fc05fe5be2813ed.png'
import instagram from '../../Assests/f0bd89e1043fabacc3dc40272d80b0bc2bddbf4a.png'
import linkeding from '../../Assests/social.png'
import { urlApiServer, urlApiServerImage } from '../../Config/Config';

function About() {
    const [about, setAbout] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [dataInformation, setDataInformation] = useState([]);
    const [isLoadingInfo, setIsLoadingInfo] = useState(true);

    // Refs para los contenedores
    const whiteContainerRef = useRef(null);
    const newSectionRef = useRef(null);
    const thirdSectionRef = useRef(null);
    const fourthSectionRef = useRef(null);
    const fifthSectionRef = useRef(null);
    const sixthSectionRef = useRef(null);
    const seventhSectionRef = useRef(null);
    const eighthSectionRef = useRef(null);
    const ninthSectionRef = useRef(null);
    const tenthSectionRef = useRef(null);
    const eleventhSectionRef = useRef(null);

    const urlGetAbout = `${urlApiServer}about-uses?populate=*`
    const urlGetContactDetail = `${urlApiServer}company-details?populate=*`


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                setIsLoading(true);
                await fetch(urlGetAbout, requestOptions)
                    .then(response => response.json())
                    .then(ContactResponse => {
                        console.log('Sobre nosotros: ', ContactResponse)
                        setAbout(ContactResponse.data || []);
                        setIsLoading(false);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente desactivado');
                setAbout([]);
                setIsLoading(false);
            }
        })();
    }, [urlGetAbout]);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                setIsLoadingInfo(true);
                await fetch(urlGetContactDetail, requestOptions)
                    .then(response => response.json())
                    .then(ContactResponse => {
                        console.log('info del Contact: ', ContactResponse.data);

                        // Asegurar que siempre sea un array
                        setDataInformation(Array.isArray(ContactResponse.data) ? ContactResponse.data : []);
                        setIsLoadingInfo(false);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente desactivado');
                setDataInformation([]); // Asegurar que sea un array vacío en caso de error
                setIsLoadingInfo(false);
            }
        })();
    }, [urlGetContactDetail]);

    // Primera sección: mostrar texto en cuanto carga la página (cuando el contenido ya está en el DOM)
    const contentReady = !isLoading && !isLoadingInfo;
    useEffect(() => {
        if (!contentReady) return;
        const el = whiteContainerRef.current;
        if (!el) return;
        const id = requestAnimationFrame(() => {
            requestAnimationFrame(() => el.classList.add('animate'));
        });
        return () => cancelAnimationFrame(id);
    }, [contentReady]);

    useEffect(() => {
        if (!contentReady) return;

        const observerOptions = {
            threshold: 0.15,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                }
            });
        }, observerOptions);

        const containers = [
            whiteContainerRef.current,
            newSectionRef.current,
            thirdSectionRef.current,
            fourthSectionRef.current,
            fifthSectionRef.current,
            sixthSectionRef.current,
            seventhSectionRef.current,
            eighthSectionRef.current,
            ninthSectionRef.current,
            tenthSectionRef.current,
            eleventhSectionRef.current
        ];

        containers.forEach(container => {
            if (container) {
                observer.observe(container);
            }
        });

        return () => {
            containers.forEach(container => {
                if (container) {
                    observer.unobserve(container);
                }
            });
        };
    }, [contentReady]);

    // Scroll effect para el icono textil
    useEffect(() => {
        const handleScroll = () => {
            const fifthSection = fifthSectionRef.current;
            if (!fifthSection) return;

            const rect = fifthSection.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const sectionHeight = rect.height;

            // Calcular el progreso de scroll (0 = inicio de la sección, 1 = final)
            const scrollProgress = Math.max(0, Math.min(1,
                (windowHeight - rect.top) / (windowHeight + sectionHeight)
            ));

            // Cuando llegue al 50% de la sección, empezar a mover el icono
            if (scrollProgress >= 0.5) {
                // Calcular el progreso desde el 50% hasta el 100% (0 a 1)
                const iconMovement = (scrollProgress - 0.5) / 0.5; // Progreso lineal desde 50% a 100%
                const iconElement = document.querySelector('.textilIcon');
                if (iconElement) {
                    const windowWidth = window.innerWidth;
                    // Distancia total para llegar al lateral izquierdo (desde la posición actual)
                    const totalDistance = windowWidth * 0.55; // Distancia desde left: 55% hasta el borde
                    const moveDistance = iconMovement * totalDistance; // Movimiento proporcional al scroll
                    const opacity = Math.max(0, 1 - iconMovement); // Ocultación proporcional al scroll
                    iconElement.style.transform = `translateX(-${moveDistance}px) scale(${1 - iconMovement * 0.2})`;
                    iconElement.style.opacity = opacity;
                }
            } else {
                // Reset cuando no ha llegado al 50%
                const iconElement = document.querySelector('.textilIcon');
                if (iconElement) {
                    iconElement.style.transform = 'translateX(0) scale(1)';
                    iconElement.style.opacity = '1';
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Scroll effect para los iconos de juventud
    useEffect(() => {
        const handleScrollJuventud = () => {
            const sixthSection = sixthSectionRef.current;
            if (!sixthSection) return;

            const rect = sixthSection.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const sectionHeight = rect.height;

            // Calcular el progreso de scroll (0 = inicio de la sección, 1 = final)
            const scrollProgress = Math.max(0, Math.min(1,
                (windowHeight - rect.top) / (windowHeight + sectionHeight)
            ));

            const iconElement = document.querySelector('.juventudIcons');
            const iconHorizontal = document.querySelector('.iconHorizontal');
            const iconVertical = document.querySelector('.iconVertical');

            if (iconElement && iconHorizontal && iconVertical) {
                if (scrollProgress > 0.1 && scrollProgress <= 0.4) {
                    // Aparición: del 10% al 40% de la sección
                    const iconMovement = (scrollProgress - 0.1) / 0.3; // 0 a 1
                    const windowWidth = window.innerWidth;
                    const totalDistance = windowWidth * 0.7;
                    const moveDistance = (1 - iconMovement) * totalDistance;
                    const opacity = Math.min(1, iconMovement * 2);

                    iconElement.style.transform = `translateY(-50%) translateX(${moveDistance}px)`;
                    iconElement.style.opacity = opacity;

                    // Resetear posiciones individuales de los iconos
                    iconHorizontal.style.transform = 'translateX(0)';
                    iconVertical.style.transform = 'translateX(0)';

                } else if (scrollProgress > 0.4 && scrollProgress <= 0.5) {
                    // Mantener en posición original: del 40% al 50% (mitad)
                    iconElement.style.transform = `translateY(-50%) translateX(0px)`;
                    iconElement.style.opacity = 1;

                    // Resetear posiciones individuales de los iconos
                    iconHorizontal.style.transform = 'translateX(0)';
                    iconVertical.style.transform = 'translateX(0)';

                } else if (scrollProgress > 0.5) {
                    // Ocultación: del 50% al final (después de la mitad)
                    const hideMovement = (scrollProgress - 0.5) / 0.5; // 0 a 1 desde el 50%
                    const windowWidth = window.innerWidth;
                    const hideDistanceHorizontal = hideMovement * windowWidth * 0.7; // Mover hacia la izquierda
                    const hideDistanceVertical = hideMovement * windowWidth * 0.7; // Mover hacia la derecha
                    const opacity = Math.max(0, 1 - hideMovement * 2);

                    // Icono horizontal se mueve hacia la izquierda
                    iconHorizontal.style.transform = `translateX(-${hideDistanceHorizontal}px)`;

                    // Icono vertical se mueve hacia la derecha
                    iconVertical.style.transform = `translateX(${hideDistanceVertical}px)`;

                    iconElement.style.opacity = opacity;

                } else {
                    // Reset cuando no ha llegado al 10%
                    iconElement.style.transform = `translateY(-50%) translateX(100vw)`;
                    iconElement.style.opacity = 0;
                    iconHorizontal.style.transform = 'translateX(0)';
                    iconVertical.style.transform = 'translateX(0)';
                }
            }
        };

        window.addEventListener('scroll', handleScrollJuventud);
        return () => window.removeEventListener('scroll', handleScrollJuventud);
    }, []);

    // Scroll effect para el icono de conciencia sostenible
    useEffect(() => {
        const handleScrollConciencia = () => {
            const seventhSection = seventhSectionRef.current;
            if (!seventhSection) return;

            const rect = seventhSection.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const sectionHeight = rect.height;

            // Calcular el progreso de scroll (0 = inicio de la sección, 1 = final)
            const scrollProgress = Math.max(0, Math.min(1,
                (windowHeight - rect.top) / (windowHeight + sectionHeight)
            ));

            const iconElement = document.querySelector('.concienciaIcon');
            if (iconElement) {
                if (scrollProgress > 0.1 && scrollProgress <= 0.4) {
                    // Aparición: del 10% al 40% de la sección
                    const iconMovement = (scrollProgress - 0.1) / 0.3; // 0 a 1
                    const windowWidth = window.innerWidth;
                    const totalDistance = windowWidth * 0.7;
                    const moveDistance = (1 - iconMovement) * totalDistance;
                    const opacity = Math.min(1, iconMovement * 2);

                    iconElement.style.transform = `translateY(-50%) translateX(-${moveDistance}px)`;
                    iconElement.style.opacity = opacity;

                } else if (scrollProgress > 0.4 && scrollProgress <= 0.5) {
                    // Mantener en posición original: del 40% al 50% (mitad)
                    iconElement.style.transform = `translateY(-50%) translateX(0px)`;
                    iconElement.style.opacity = 1;

                } else if (scrollProgress > 0.5) {
                    // Ocultación: del 50% al final (después de la mitad)
                    const hideMovement = (scrollProgress - 0.5) / 0.5; // 0 a 1 desde el 50%
                    const windowWidth = window.innerWidth;
                    const hideDistance = hideMovement * windowWidth * 0.7; // Mover hacia la derecha
                    const opacity = Math.max(0, 1 - hideMovement * 2);

                    iconElement.style.transform = `translateY(-50%) translateX(${hideDistance}px)`;
                    iconElement.style.opacity = opacity;

                } else {
                    // Reset cuando no ha llegado al 10%
                    iconElement.style.transform = `translateY(-50%) translateX(-100vw)`;
                    iconElement.style.opacity = 0;
                }
            }
        };

        window.addEventListener('scroll', handleScrollConciencia);
        return () => window.removeEventListener('scroll', handleScrollConciencia);
    }, []);

    // Efecto para manejar el scroll de la octava sección
    useEffect(() => {
        const handleScrollFenix = () => {
            const eighthSection = eighthSectionRef.current;
            if (!eighthSection) return;

            const rect = eighthSection.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const sectionHeight = rect.height;

            // Calcular el progreso de scroll (0 = inicio de la sección, 1 = final)
            const scrollProgress = Math.max(0, Math.min(1,
                (windowHeight - rect.top) / (windowHeight + sectionHeight)
            ));

            const iconElement = document.querySelector('.fenixIcon');

            if (iconElement) {
                if (scrollProgress > 0.1 && scrollProgress <= 0.4) {
                    // Aparición: del 10% al 40% de la sección
                    const iconMovement = (scrollProgress - 0.1) / 0.3; // 0 a 1
                    const windowWidth = window.innerWidth;
                    const totalDistance = windowWidth * 0.7;
                    const moveDistance = (1 - iconMovement) * totalDistance;
                    const opacity = Math.min(1, iconMovement * 2);

                    iconElement.style.transform = `translateY(-50%) translateX(${moveDistance}px)`;
                    iconElement.style.opacity = opacity;

                } else if (scrollProgress > 0.4 && scrollProgress <= 0.5) {
                    // Mantener en posición original: del 40% al 50% (mitad)
                    iconElement.style.transform = `translateY(-50%) translateX(0px)`;
                    iconElement.style.opacity = 1;

                } else if (scrollProgress > 0.5) {
                    // Ocultación: del 50% al final (después de la mitad)
                    const hideMovement = (scrollProgress - 0.5) / 0.5; // 0 a 1 desde el 50%
                    const windowWidth = window.innerWidth;
                    const hideDistance = hideMovement * windowWidth * 0.7; // Mover hacia la izquierda
                    const opacity = Math.max(0, 1 - hideMovement * 2);

                    iconElement.style.transform = `translateY(-50%) translateX(-${hideDistance}px)`;
                    iconElement.style.opacity = opacity;

                } else {
                    // Reset cuando no ha llegado al 10%
                    iconElement.style.transform = `translateY(-50%) translateX(100vw)`;
                    iconElement.style.opacity = 0;
                }
            }
        };

        window.addEventListener('scroll', handleScrollFenix);
        return () => window.removeEventListener('scroll', handleScrollFenix);
    }, []);

    // Efecto de scroll para la sección Legado
    useEffect(() => {
        const handleScrollLegado = () => {
            if (!tenthSectionRef.current) return;

            const rect = tenthSectionRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Calcular el progreso del scroll dentro de la sección
            const scrollProgress = Math.max(0, Math.min(1, (windowHeight - rect.top) / windowHeight));

            // Aplicar efectos al texto
            const textElement = tenthSectionRef.current.querySelector('.legadoTexto');

            if (textElement) {
                const textProgress = Math.max(0, Math.min(1, scrollProgress * 2));

                textElement.style.opacity = textProgress;
                textElement.style.transform = `translateY(${(1 - textProgress) * 150}px) scale(${0.8 + (textProgress * 0.2)})`;
            }
        };

        window.addEventListener('scroll', handleScrollLegado);
        return () => window.removeEventListener('scroll', handleScrollLegado);
    }, []);

    // Scroll effect para los textos de productos
    useEffect(() => {
        const handleScrollProductos = () => {
            if (eleventhSectionRef.current) {
                const rect = eleventhSectionRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                // Si la sección está en el viewport
                if (rect.top < windowHeight && rect.bottom > 0) {
                    const scrollProgress = Math.max(0, Math.min(1, (windowHeight - rect.top) / windowHeight));

                    // Aplicar animación a los textos
                    const productosTitle = eleventhSectionRef.current.querySelector('.productosTitle');
                    const abrigosSection = eleventhSectionRef.current.querySelector('.abrigosSection');
                    const sueterSection = eleventhSectionRef.current.querySelector('.sueterSection');
                    const accesoriosSection = eleventhSectionRef.current.querySelector('.accesoriosSection');

                    if (productosTitle) {
                        const titleProgress = Math.max(0, Math.min(1, scrollProgress * 2));
                        productosTitle.style.opacity = titleProgress;
                        productosTitle.style.transform = `translateY(${(1 - titleProgress) * 50}px)`;
                    }

                    if (abrigosSection) {
                        const abrigosProgress = Math.max(0, Math.min(1, (scrollProgress - 0.1) * 2));
                        abrigosSection.style.opacity = abrigosProgress;
                        abrigosSection.style.transform = `translateY(${(1 - abrigosProgress) * 50}px)`;
                    }

                    if (sueterSection) {
                        const sueterProgress = Math.max(0, Math.min(1, (scrollProgress - 0.2) * 2));
                        sueterSection.style.opacity = sueterProgress;
                        sueterSection.style.transform = `translateY(${(1 - sueterProgress) * 50}px)`;
                    }

                    if (accesoriosSection) {
                        const accesoriosProgress = Math.max(0, Math.min(1, (scrollProgress - 0.3) * 2));
                        accesoriosSection.style.opacity = accesoriosProgress;
                        accesoriosSection.style.transform = `translateY(${(1 - accesoriosProgress) * 50}px)`;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScrollProductos);
        return () => window.removeEventListener('scroll', handleScrollProductos);
    }, []);

    // Efecto para el merge de iconos en la novena sección
    useEffect(() => {
        const handleScrollMerge = () => {
            const ninthSection = ninthSectionRef.current;
            if (!ninthSection) return;

            const rect = ninthSection.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const sectionHeight = rect.height;

            // Calcular el progreso del scroll dentro de la sección (0 a 1)
            const scrollProgress = Math.max(0, Math.min(1,
                (windowHeight - rect.top) / sectionHeight
            ));

            const textilIcon = document.querySelector('.textilMerge');
            const juventudIcon = document.querySelector('.juventudMerge');
            const concienciaIcon = document.querySelector('.concienciaMerge');
            const fenixIcon = document.querySelector('.fenixMerge');
            const finalLogo = document.querySelector('.finalLogo');

            if (textilIcon && juventudIcon && concienciaIcon && fenixIcon && finalLogo) {
                // Los iconos empiezan separados y se mueven hacia el centro
                const distance = 400 * (1 - scrollProgress); // Distancia desde el centro

                // Textil - viene desde arriba izquierda
                textilIcon.style.transform = `translate(${-distance}px, ${-distance}px) scale(${1 - scrollProgress * 0.5})`;
                textilIcon.style.opacity = scrollProgress < 0.9 ? 1 - scrollProgress * 0.5 : 0;

                // Juventud - viene desde arriba derecha
                juventudIcon.style.transform = `translate(${distance}px, ${-distance}px) scale(${1 - scrollProgress * 0.5})`;
                juventudIcon.style.opacity = scrollProgress < 0.9 ? 1 - scrollProgress * 0.5 : 0;

                // Conciencia - viene desde abajo izquierda
                concienciaIcon.style.transform = `translate(${-distance}px, ${distance}px) scale(${1 - scrollProgress * 0.5})`;
                concienciaIcon.style.opacity = scrollProgress < 0.9 ? 1 - scrollProgress * 0.5 : 0;

                // Fenix - viene desde abajo derecha
                fenixIcon.style.transform = `translate(${distance}px, ${distance}px) scale(${1 - scrollProgress * 0.5})`;
                fenixIcon.style.opacity = scrollProgress < 0.9 ? 1 - scrollProgress * 0.5 : 0;

                // Logo final aparece cuando los iconos están casi fusionados
                if (scrollProgress > 0.7) {
                    finalLogo.style.opacity = (scrollProgress - 0.7) / 0.3;
                } else {
                    finalLogo.style.opacity = 0;
                }
            }
        };

        window.addEventListener('scroll', handleScrollMerge);
        return () => window.removeEventListener('scroll', handleScrollMerge);
    }, []);

    if (isLoading || isLoadingInfo) {
        return (
            <div className="aboutusLoading">
                <div className="spinner"></div>
                <p>Cargando contenido...</p>
            </div>
        );
    }

    return (
        <div>
            {about.length > 0 && (
                <div className="bannerContainer" style={{ backgroundImage: `url(${urlApiServerImage + about[0]?.imagen?.url})` }}>
                    <img src={logoBanner} alt="logoBanner" className="logoBanner" />
                </div>
            )}
            <div className="whiteContainerAbout" ref={whiteContainerRef}>
                <img src="/assets/aboutus/chica con buzo.png" alt="Chica con buzo" className="chicaBuzoImage" />
                <div className="contentBoxAbout">
                    {/* Contenido para agregar */}
                </div>
                <div className="blueRectangleAbout">
                    {/* Rectángulo azul */}
                </div>
                <div className="quienesSomosText">
                    QUIENES SOMOS?
                </div>
                <div className="aboutTextContainer">
                    <p className="aboutText">
                        En REBORN PTY, no solo confeccionamos textiles; nos dedicamos a "Dressing the Soul" — vistiendo el alma, los sueños y los recuerdos de una
                        generación. Entendemos que la etapa colegial culmina en un momento único: la graduación. Por eso, somos tu aliado en la creación de pren-
                        das y accesorios totalmente personalizados que no solo identifican a tu promoción, sino que también cuentan su historia, celebran su unión y
                        marcan el inicio de un nuevo capítulo.
                    </p>
                    <p className="aboutText">
                        Nos enorgullece ser una empresa colmbopanameña comprometida con la excelencia y la innovación. Utilizamos tecnología de punta y, en su
                        mayoría, insumos con certificado ambiental, porque sabemos que vestir el futuro también significa cuidar el planeta. Cada sudadera, toga o pin
                        que creamos es una pieza de alta calidad, diseñada para perdurar como un testimonio tangible de los lazos que se forjaron y las metas que se
                        alcanzaron.
                    </p>
                    <p className="aboutText">
                        En REBORN PTY, vestimos más que cuerpos: vestimos el espíritu de equipo, el orgullo de los logros y la emoción de un adiós que es también un
                        gran hola.
                    </p>
                </div>
                <div className="redRectangleAbout">
                    {/* Rectángulo rojo */}
                </div>
                <div className="propositoText">
                    PROPÓSITO
                </div>
                <div className="propositoContentContainer">
                    <p className="propositoContent">
                        PROPÓSITO: El propósito de REBORN PTY en Panamá es proporcionar productos textiles de alta calidad que satisfagan las necesidades únicas de la comunidad estudiantil e industrial en Panamá y el mundo.
                    </p>
                    <p className="propositoContent">
                        Esto podría incluir una amplia gama de productos, como uniformes hechos a medida, ropa fresca cómoda, indumentarias personalizadas y accesorios varios relacionados a tu team.
                    </p>
                </div>
            </div>
            <div className="newSectionAbout" ref={newSectionRef}>
                <img src="/assets/aboutus/chicas.png" alt="Chicas" className="chicasImage" />
                <div className="blueRectangleNewSection">
                    {/* Rectángulo azul */}
                </div>
                <div className="misionText">
                    MISIÓN
                </div>
                <div className="misionContentContainer">
                    <p className="misionContent">
                        La misión REBORN PTY es convertirse en el proveedor preferido de productos textiles para colegios, universidades y empresas en Panamá y el mundo.
                    </p>
                    <p className="misionContent">
                        Esto podría lograrse aprovechando la tecnología de punta, apuntando al cuidado del planeta, trabajando en su mayoría insumos con certificado ambiental, empleando profesionales capacitados y manteniendo un compromiso con la excelencia en todos los aspectos del negocio.
                    </p>
                </div>
                <div className="redRectangleNewSection">
                    {/* Rectángulo rojo */}
                </div>
                <div className="visionText">
                    VISIÓN
                </div>
                <div className="visionContentContainer">
                    <p className="visionContent">
                        La visión de REBORN PTY es revolucionar la industria textil universitaria, colegial e industrial en Panamá a través de productos, servicios y prácticas comerciales innovadoras.
                    </p>
                    <p className="visionContent">
                        Esto incluye invertir en investigación y desarrollo para crear nuevos productos que satisfagan las necesidades cambiantes de la comunidad, expandirse a nuevos mercados y formar alianzas estratégicas para mejorar las capacidades y el alcance de la empresa.
                    </p>
                    <p className="visionContent">
                        En última instancia, la visión de la empresa es convertirse en el proveedor de productos textiles más confiable y respetado en Panamá y más allá.
                    </p>
                </div>
            </div>
            <div className="thirdSectionAbout" ref={thirdSectionRef}>
                <img src="/assets/aboutus/buzo.png" alt="Buzo" className="buzoImage" />
                <div className="redRectangleThirdSection">
                    {/* Rectángulo rojo */}
                </div>
                <div className="valoresText">
                    VALORES
                </div>
                <div className="valoresContentContainer">
                    <p className="valoresContent">PASIÓN</p>
                    <p className="valoresContent">CONCIENCIA SOSTENIBLE</p>
                    <p className="valoresContent">CREATIVIDAD</p>
                    <p className="valoresContent">AMOR</p>
                    <p className="valoresContent">INCLUSIÓN</p>
                    <p className="valoresContent">SUEÑOS</p>
                </div>
            </div>
            <div className="fourthSectionAbout" ref={fourthSectionRef}>
                <img src="/assets/aboutus/grupito de chicas.png" alt="Grupito de chicas" className="grupitoChicasImage" />
                <div className="contentBoxFourthSection">
                    {/* Contenedor disfuminado blanco */}
                </div>
                <div className="blueRectangleFourthSection">
                    {/* Rectángulo azul */}
                </div>
                <div className="universosText">
                    UNIVERSOS
                </div>
                <div className="universosContentContainer">
                    <p className="universosContent">
                        Los mundos en los cuales nuestra marca coexiste, donde habita y de donde se desprenden nuestros principales conceptos y focos de inspiración.
                    </p>
                    <div className="universosTerms">
                        <p className="universosTerm">TEXTIL / MODA</p>
                        <p className="universosTerm">JUVENTUD/ALEGRÍA</p>
                        <p className="universosTerm">CONCIENCIA SOSTENIBLE</p>
                        <p className="universosTerm">RENACER</p>
                    </div>
                    <p className="universosContent">
                        Sí, extraemos de cada universo su elemento más representativo y lo llevábamos a su mínima expresión, nos damos cuenta que aún podemos identificar de que se trata, consiguiendo un sello único para nuestra marca.
                    </p>
                </div>
            </div>

            {/* Nueva Sección Parallax */}
            <Parallax
                bgImage="/assets/aboutus/fondo textil.png"
                strength={200}
                className="fifthSectionAbout"
            >
                <div className="fifthSectionParallax" ref={fifthSectionRef}>
                    {/* Contenido de la nueva sección */}
                    <div className="fifthSectionContent">
                        <p className="paragraphSectionsParallax">
                            Nuestros Productos y Servicios: ¡Viste Tu Legado!<br />
                            En REBORN PTY, sabemos que la graduación es un hito inolvidable.<br />
                            Estamos aquí para ayudarte a celebrar ese momento especial con productos<br />
                            totalmente personalizados que capturan la esencia, los recuerdos y el espíritu<br />
                            de tu clase. ¡Prepara tu promo para lucir unida y con estilo!
                        </p>
                        <img src="/assets/aboutus/textil.png" alt="Icono Textil" className="textilIcon" />
                        <div className="textilModaText">TEXTIL / MODA</div>
                    </div>
                </div>
            </Parallax>

            {/* Nueva Sección 6 Parallax */}
            <Parallax
                bgImage="/assets/aboutus/fondo juventud.png"
                strength={200}
                className="sixthSectionAbout"
            >
                <div className="sixthSectionParallax" ref={sixthSectionRef}>
                    <div className="sixthSectionContent">
                        <p className="paragraphSectionsParallax">
                            1. Prendas Exclusivas para Tu Promo<br />
                            Sudaderas con Identidad: Abrigos hoodie, varsity jacket y bomber jacket. Diseña la sudadera perfecta que grite "¡Somos la promo 2026 !" con estilo, calidez y un diseño que todos querrán guardar para siempre.<br />
                            Camisetas Personalizadas: Desde el clásico suéter polo hasta las opciones deportivas dry-fit y t-shirt. Ideales para eventos pre-graduación, excursiones o el día a día en el colegio.<br />
                            Joggers Confortables: Comodidad y estilo para la vida activa de tu promo, con un toque personalizado que los hará únicos.<br />
                        </p>
                        <div className="juventudIcons">
                            <div className="iconHorizontal">
                                <div className="bar"></div>
                                <div className="bar"></div>
                                <div className="bar"></div>
                                <div className="bar"></div>
                            </div>
                            <div className="iconVertical">
                                <div className="bar"></div>
                                <div className="bar"></div>
                                <div className="bar"></div>
                                <div className="bar"></div>
                            </div>
                        </div>
                        <div className="juventudAlegriaText">JUVENTUD / ALEGRÍA</div>
                    </div>
                </div>
            </Parallax>

            {/* Nueva Sección 7 Parallax */}
            <Parallax
                bgImage="/assets/aboutus/fondo conciencia.png"
                strength={200}
                className="seventhSectionAbout"
            >
                <div className="seventhSectionParallax" ref={seventhSectionRef}>
                    <div className="seventhSectionContent">
                        <p className="paragraphSectionsParallax">
                            2. Accesorios Inolvidables para Tu Graduación<br />
                            Gorras y Pines con tu Sello: Crea gorras y pines que representen el logo de tu promo, un lema especial o la mascota de tu colegio. Pequeños detalles que hacen una gran diferencia.<br />
                            Indumentaria de Ceremonia: Hacemos de tu acto de grado un momento sublime con estolas, birretes y togas de grado diseñados para tu promoción, y elegantes pañoletas para un toque distintivo.<br />
                        </p>
                        <img src="/assets/aboutus/conciencia sostenible.png" alt="Icono Conciencia Sostenible" className="concienciaIcon" />
                        <div className="concienciaSostenibleText">CONCIENCIA SOSTENIBLE</div>
                    </div>
                </div>
            </Parallax>

            {/* Nueva Sección 8 */}
            <div className="eighthSectionAbout" style={{ backgroundImage: `url('/assets/aboutus/fondo fenix.png')` }} ref={eighthSectionRef}>
                <div className="eighthSectionContent">
                    <p className="paragraphSectionsParallax">
                        Memorabilia Duradera: Guarda los recuerdos con termos personalizados con el diseño de tu clase y lanyards para tus identificaciones o eventos especiales.<br />
                        Cada uno de nuestros productos se elabora con insumos de la más alta calidad y un cuidado excepcional, garantizando que tu promo no solo vista el alma, sino que también atesore un recuerdo duradero de una etapa inolvidable.<br />
                    </p>
                    <img src="/assets/aboutus/fenix.png" alt="Icono Fenix" className="fenixIcon" />
                    <div className="fenixRenacerText">FÉNIX / RENACER</div>
                </div>
            </div>

            {/* Nueva Sección 9 - Merge de Iconos */}
            <div className="ninthSectionAbout" ref={ninthSectionRef}>
                <div className="logoMergeContainer">
                    <img src="/assets/aboutus/textil.png" alt="Textil" className="mergeIcon textilMerge" />
                    <img src="/assets/aboutus/juventud.png" alt="Juventud" className="mergeIcon juventudMerge" />
                    <img src="/assets/aboutus/conciencia sostenible.png" alt="Conciencia" className="mergeIcon concienciaMerge" />
                    <img src="/assets/aboutus/fenix.png" alt="Fenix" className="mergeIcon fenixMerge" />
                    <img src="/assets/aboutus/logo.png" alt="Logo Final" className="finalLogo" />
                </div>
            </div>

            {/* Nueva Sección 10 */}
            <div className="tenthSectionAbout" style={{ backgroundImage: `url('/assets/aboutus/fondo legado.png')` }} ref={tenthSectionRef}>
                <div className="legadoContent">
                    <div className="legadoTexto">" ¡VISTE TU LEGADO! "</div>
                </div>
            </div>

            {/* Nueva Sección 11 */}
            <div className="eleventhSectionAbout" style={{ backgroundImage: `url('/assets/aboutus/fondo reborn spinning.jpg')` }} ref={eleventhSectionRef}>
                <div className="eleventhSectionOverlay">
                    <div className="productosContent">
                        <div className="productosTitle">PRODUCTOS:</div>
                        <div className="abrigosSection">
                            <div className="abrigosTitle">ABRIGOS:</div>
                            <div className="abrigosList">JACKET VARSITY, JACKET BOMBER, HOODIE, BOMBER HOODIE, CORTAVIENTOS</div>
                        </div>
                        <div className="sueterSection">
                            <div className="sueterTitle">SUETER:</div>
                            <div className="sueterList">POLO, DRYFIT, TSHIRT, CAMISA BOTON, CAMIBUZOS, BEISBOLERAS, TSHIRT FUTBOL AMERICANO.</div>
                        </div>
                        <div className="accesoriosSection">
                            <div className="accesoriosTitle">ACCESORIOS:</div>
                            <div className="accesoriosList">PINES, TERMOS, PAÑOLETAS, GORRAS, MEDALLAS, ESTOLAS, LANDYARD, TOGAS, BIRRETES.</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Nueva Sección 12 */}
            <div className="twelfthSectionAbout">
                <img src="/assets/aboutus/texto logo reborn abountus.png" alt="Texto Logo Reborn Aboutus" className="textoLogoRebornAboutus" />
                <img src="/assets/aboutus/logo reborn abountus.png" alt="Logo Reborn Aboutus" className="logoRebornAboutus" />

                <div className="contactInfo">
                    <div className="companyName">REBORN INTERNATIONAL COMPANY S.A</div>
                    {dataInformation.length > 0 && (
                        <>
                            <div className="address">Sede panamá: {dataInformation[0]?.Sede || "..."}</div>
                            <div className="address">Fabrica en colombia : {dataInformation[0]?.Fabrica || "..."}</div>
                            <div className="nit">NIT: {dataInformation[0]?.NIT || "..."}</div>

                            <div className="ceoInfo">
                                <div className="ceoName">{dataInformation[0]?.CEO || "..."}</div>
                                <div className="ceoPhone">CEL: {dataInformation[0]?.CelularCEO || "..."}</div>
                            </div>

                            <div className="advisorInfo">
                                <div className="advisorName">ASESOR PTY: {dataInformation[0]?.ASESOR || "..."}</div>
                                <div className="advisorPhone">WS:ASESOR PTY: {dataInformation[0]?.WhatsappAsesor || "..."}</div>
                            </div>
                        </>
                    )}

                    <div className="socialMedia">REDES SOCIALES: REBORN.PTY</div>
                    <div className='imgSocialNetworkArticleHome'>
                        {dataInformation.length > 0 && dataInformation[0]?.Facebook_url && (
                            <a href={dataInformation[0].Facebook_url}>
                                <img src={facebook} alt='facebook' className='socialNetworksArticuleAbout' />
                            </a>
                        )}
                        {dataInformation.length > 0 && dataInformation[0]?.x_url && (
                            <a href={dataInformation[0].x_url}>
                                <img src={x} alt='x' className='socialNetworksArticuleAbout' />
                            </a>
                        )}
                        {dataInformation.length > 0 && dataInformation[0]?.instagram_url && (
                            <a href={dataInformation[0].instagram_url}>
                                <img src={instagram} alt='instagram' className='socialNetworksArticuleAbout' />
                            </a>
                        )}
                        {dataInformation.length > 0 && dataInformation[0]?.linkeding_url && (
                            <a href={dataInformation[0].linkeding_url}>
                                <img src={linkeding} alt='linkeding' className='socialNetworksFooter optionsSocialNetworksFooter' />
                            </a>
                        )}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default About;
